import { createApp } from 'vue'
import { createPinia } from 'pinia'
import QicConnectPlugin from '@qicgroupdoha/qic-connect-ds/plugin'
import VueScrollTo from 'vue-scrollto'
import packageJson from '../../package.json'

import { i18n } from '@/app/plugins/i18n'
import { SentryLib } from '@/app/plugins/sentry/sentry'

import App from '@/App.vue'
import router from '@/app/router'

import { clarityService } from '@qicgroupdoha/qic-use/clarity'

import '@qicgroupdoha/loyalty-components/style.css'
import '@qicgroupdoha/qic-connect-ds/style.css'
import '@/shared/assets/styles/main.scss'

const logVersion = () => {
  console.log(`version: ${packageJson.version}.${__COMMIT_HASH__}`)
}

logVersion()

const app = createApp(App)

SentryLib.init(app, router)

app.use(i18n)
const pinia = createPinia()
pinia.use(({ store }) => {
  store.$router = router
})

app.use(pinia)
app.use(router)

app.use(VueScrollTo)

app.use(QicConnectPlugin, {
  breakpoints: {
    mobile: 768,
  },
})

clarityService.init({
  projectId: import.meta.env.VUE_APP_CLARITY_PROJECT_ID,
  router,
  trackedQueryKeys: ['platform', 'version'],
})

app.mount('#app')
